import { makeRequest } from 'Douleutaras/services/apiClient';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject, UserSettings } from 'Douleutaras/types/index';

const SETTINGS_ENDPOINT = 'api/public/v3/user/settings/';

export const patchUserSettings = createAsyncThunk(
  'user/settings/patch',
  async (args: { id: number; [k: string]: string | number | boolean; }, api) => {
    const { id, ...attributes } = args;

    const response = await makeRequest(
      SETTINGS_ENDPOINT,
      {
        method: 'PATCH',
        body: {
          data: {
            type: 'users',
            id,
            attributes
          }
        }
      }
    )(api);

    return response.data;
  }
);

export const fetchUserSettings = createAsyncThunk(
  'user/settings/fetch',
  async (_, api) => {
    const response = await makeRequest(
      SETTINGS_ENDPOINT,
      {
        method: 'GET'
      }
    )(api);

    return response.data;
  }
);

export const settingsSlice = createSlice({
  name: 'userSettings',
  initialState: {
    loading: false,
    error: false,
    settings: {} as JSONApiDataObject<UserSettings>
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchUserSettings.pending, (state, action) => {
      return { ...state, loading: true, error: false };
    });
    builder.addCase(fetchUserSettings.rejected, (state, action) => {
      return { ...state, loading: false, error: true };
    });
    builder.addCase(fetchUserSettings.fulfilled, (state, action) => {
      return { ...state, settings: action.payload?.data, loading: false, error: false };
    });

    builder.addCase(patchUserSettings.fulfilled, (state, action) => {
      return { ...state, settings: action.payload.data, loading: false, error: false };
    });
    builder.addCase(patchUserSettings.pending, (state, action) => {
      return { ...state, loading: true, error: false };
    });
    builder.addCase(patchUserSettings.rejected, (state, action) => {
      return { ...state, loading: false, error: true };
    });
  }
});
